import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.groupPredictContractChart = echarts.init(this.element.querySelector('#group-predict-contract-chart'));
    this.groupPredictContractPerStaffChart = echarts.init(this.element.querySelector('#group-predict-contract-chart-per-staff'));
    this.groupPredictContractPerWorkerChart = echarts.init(this.element.querySelector('#group-predict-contract-chart-per-worker'));

    const xAxisData = JSON.parse(this.data.get("x_axis"));
    const orgCodes = JSON.parse(this.data.get("org_codes"));
    const contractConvert = JSON.parse(this.data.get("contract_convert"));
    const convertRealAmount = JSON.parse(this.data.get("convert_real_amount"));
    const contractConvertTotals = JSON.parse(this.data.get("contract_convert_totals"));
    const contractConvertTotalsPerStaff = JSON.parse(this.data.get("contract_convert_totals_per_staff"));
    const contractConvertTotalsPerWorker = JSON.parse(this.data.get("contract_convert_totals_per_worker"));

    const option = {
      legend: {
        data: ['跟踪合同额（万元）','跟踪合同额（成功率小于80%）','流转中合同额（成功率等于80%）'],
        align: 'left'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      grid: {
        left: 70,
        right: 110,
        top: 50,
        bottom: 100
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
              pixelRatio: 2
          }
        }
      },
      xAxis: {
        data: xAxisData,
        silent: true,
        axisLabel: {
          interval: 0,
          rotate: -40,
          margin: 24
        },
        splitLine: {
            show: false
        }
      },
      yAxis: [{
        type: 'value',
        name: '跟踪合同额（万元）',
        position: 'left',
        axisLabel: {
          formatter: '{value}万'
        },
        min: 0
      }],
      series: [{
        name: '跟踪合同额（万元）',
        type: 'bar',
        barWidth: '30%',
        barGap: '-100%',
        data: contractConvertTotals,
        itemStyle: {
          color: '#DDDDDD'
        },
        label: {
          show: true,
          color: '#353535',
          position: 'top'
        }
      },{
        name: '跟踪合同额（成功率小于80%）',
        type: 'bar',
        stack: '总量',
        data: contractConvert,
        barWidth: 20,
        itemStyle: {
          color: '#738496'
        },
        label: {
          show: true,
          position: 'top'
        }
      },{
        name: '流转中合同额（成功率等于80%）',
        type: 'bar',
        stack: '总量',
        data: convertRealAmount,
        barWidth: 20,
        itemStyle: {
          color: '#334B5C'
        },
        label: {
          show: false
        }
      }]
    };

    function drill_down_contract_detail(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'bar') {
          const org_code = orgCodes[params.dataIndex];
          const month_name = $('#month_name').val();
          let url;
          url = '/report/predict_contract?view_deptcode_sum=true&org_code=' + org_code + '&month_name=' + encodeURIComponent(month_name);
          Turbo.visit(url);
        }
      }
    }

    const option_per_staff = {
      title: {
        text: '全员人均跟踪合同额',
        textStyle: {
          fontSize: 12,
        }
      },
      legend: {
          data: ['全员人均跟踪合同额（万元）'],
          align: 'left'
      },
      grid: {
        left: 50,
        right: 110,
        top: 60,
        bottom: 125
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
              pixelRatio: 2
          }
        }
      },
      xAxis: {
        data: xAxisData,
        silent: true,
        axisLabel: {
          interval: 0,
          rotate: -40
        },
        splitLine: {
            show: false
        }
      },
      yAxis: {
        axisLabel: {
          show: true,
          interval: 'auto',
          formatter: '{value}万'
        }
      },
      series: [{
        name: '全员人均跟踪合同额（万元）',
        type: 'bar',
        data: contractConvertTotalsPerStaff,
        barMaxWidth: 48,
        label: {
          show: true,
          position: 'top',
          fontWeight: 'bold',
          color: '#000000'
        },
        itemStyle: {
          color: '#738496'
        }
      }]
    };

    const option_per_worker = {
      title: {
        text: '一线人均跟踪合同额',
        textStyle: {
          fontSize: 12,
        }
      },
      legend: {
          data: ['一线人均跟踪合同额（万元）'],
          align: 'left'
      },
      grid: {
        left: 50,
        right: 110,
        top: 60,
        bottom: 125
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
              pixelRatio: 2
          }
        }
      },
      xAxis: {
        data: xAxisData,
        silent: true,
        axisLabel: {
          interval: 0,
          rotate: -40
        },
        splitLine: {
            show: false
        }
      },
      yAxis: {
        axisLabel: {
          show: true,
          interval: 'auto',
          formatter: '{value}万'
        }
      },
      series: [{
        name: '一线人均跟踪合同额（万元）',
        type: 'bar',
        data: contractConvertTotalsPerWorker,
        barMaxWidth: 48,
        label: {
          show: true,
          position: 'top',
          fontWeight: 'bold',
          color: '#000000'
        },
        itemStyle: {
          color: '#738496'
        }
      }]
    };

    this.groupPredictContractChart.setOption(option, false);
    this.groupPredictContractChart.on('click', drill_down_contract_detail);
    this.groupPredictContractPerStaffChart.setOption(option_per_staff, false);
    this.groupPredictContractPerWorkerChart.setOption(option_per_worker, false);

    this.charts = [this.groupPredictContractChart, this.groupPredictContractPerStaffChart, this.groupPredictContractPerWorkerChart];
    this.updateTheme();
    this.themeObserver = new MutationObserver(() => this.updateTheme());
    this.themeObserver.observe(document.documentElement, {
      attributes: true, attributeFilter: ['data-coreui-theme', 'data-bs-theme']
    });
    this.resizeObserver = new ResizeObserver(() => this.layout());
    this.resizeObserver.observe(this.element);
  }

  updateTheme() {
    const styles = getComputedStyle(this.element);
    const text = styles.color;
    const background = styles.getPropertyValue('--cui-body-bg').trim() || '#fff';
    const dark = document.documentElement.getAttribute('data-coreui-theme') === 'dark';
    const colors = dark ? ['#b7c4d4', '#79b8ed', '#42c7b5'] : ['#dddddd', '#527da5', '#27695f'];

    this.charts.forEach((chart, index) => {
      chart.setOption({
        textStyle: { color: text },
        title: { textStyle: { color: text } },
        legend: { textStyle: { color: text }, inactiveColor: dark ? '#8993a3' : '#767676' },
        tooltip: { backgroundColor: background, borderColor: text, textStyle: { color: text }, confine: true },
        toolbox: {
          iconStyle: { borderColor: text },
          feature: { dataView: { backgroundColor: background, textareaColor: background, textColor: text }, saveAsImage: { backgroundColor: background } }
        },
        xAxis: { axisLabel: { color: text }, axisLine: { lineStyle: { color: text, opacity: 0.5 } } },
        yAxis: {
          axisLabel: { color: text }, nameTextStyle: { color: text },
          splitLine: { lineStyle: { color: text, opacity: 0.16 } }
        },
        series: Array.from({ length: index === 0 ? 3 : 1 }, (_, seriesIndex) => ({
          itemStyle: { color: colors[index === 0 ? seriesIndex : 1] },
          label: { color: text, position: 'top', formatter: params => Number(params.value) === 0 ? '' : params.value },
          labelLayout: { hideOverlap: true }
        }))
      });
    });
  }

  layout() {
    this.groupPredictContractChart.resize();
    this.groupPredictContractPerStaffChart.resize();
    this.groupPredictContractPerWorkerChart.resize();
  }

  disconnect() {
    this.themeObserver?.disconnect();
    this.resizeObserver?.disconnect();
    this.groupPredictContractChart.dispose();
    this.groupPredictContractPerStaffChart.dispose();
    this.groupPredictContractPerWorkerChart.dispose();
  }
}
